export default "__VITE_ASSET__DDHWF_s4__"